const REGEX_SHOPIFY_PNG = /https?:\/\/+cdn.shopify.com.+([^\/]+).png.+([^\/]+)/

export const isShopifyPNGImage = (src: string) => {
  const result = REGEX_SHOPIFY_PNG.exec(src)
  return Boolean(result)
}
